import React from 'react';
import classNames from 'classnames';
import { TextListItem } from '@eventbrite/eds-text-list-item';
import { Icon } from '@eventbrite/eds-icon';
import { Divider } from '@eventbrite/eds-divider';
import { Check } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import FeeAndTaxContent from '../FeeAndTaxContent';

const variantListItemStyle = {
    listStyle: 'none',
};

const VariantListItem = (props) => {
    const {
        isSelected,
        onSelect,
        showDivider,
        discountedCost,
        variantCost,
        extraContent,
        statusDisplayOptions,
        displayName,
        isFormSubmitting,
        isEventWithShippingFee,
        feeAndTax,
    } = props;
    let costDisplayContent;
    const divider = showDivider ? <Divider /> : null;
    const selectedIcon = isSelected ? (
        <div
            className="eds-align--center-vertical"
            data-spec="selected-variant-indicator"
        >
            <Icon type={<Check />} />
        </div>
    ) : null;
    const isDisabled = statusDisplayOptions.isDisabled || isFormSubmitting;
    const sublineContainerClassName = classNames('eds-text-bm--fixed');
    const feeAndTaxContent =
        isEventWithShippingFee && feeAndTax ? (
            <FeeAndTaxContent feesAndTaxes={feeAndTax}></FeeAndTaxContent>
        ) : null;

    if (statusDisplayOptions.isDisabled) {
        const statusText = (
            <span
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={statusDisplayOptions.statusHtml}
                data-spec="tiered-ticket-onsale-status-description"
            />
        );

        costDisplayContent = (
            <span>
                {gettext('%(variantCost)s', { variantCost })} - {statusText}
            </span>
        );
    } else {
        costDisplayContent = (
            <span>
                {variantCost}
                {discountedCost}
                {feeAndTaxContent}
            </span>
        );
    }

    const item = (
        <TextListItem
            extraContent={extraContent}
            isDisabled={isDisabled}
            onSelect={onSelect}
            buttonType="link"
        >
            <div
                className={classNames(
                    'select-ticket-variant__contents',
                    'eds-align--space-between',
                    {
                        'eds-text-color--ui-500': isDisabled,
                    },
                )}
                data-spec="select-ticket-variant__contents"
            >
                <div>
                    {displayName}
                    <div
                        className={sublineContainerClassName}
                        data-spec="ticket-variant-cost"
                    >
                        {costDisplayContent}
                    </div>
                </div>
                {selectedIcon}
            </div>
        </TextListItem>
    );

    return (
        <li style={variantListItemStyle}>
            {item}
            {divider}
        </li>
    );
};

export default VariantListItem;
